/*eslint-disable */
'use strict';

/**
 * Didn't end up using a library like handlebars or ejs
 * because we want to keep this bundle as small as possible.
 */

// John Resig - http://ejohn.org/ - MIT Licensed
// Simple JavaScript Templating
// http://ejohn.org/blog/javascript-micro-templating/
var cache = {};

function render(str, data) {
  // Figure out if we're getting a template, or if we need to
  // load the template - and be sure to cache the result.
  data = data || {};

  var fn = !/\W/.test(str) ?
      cache[str] = cache[str] ||
          render(document.getElementById(str).innerHTML) :

      // Generate a reusable function that will serve as a template
      // generator (and which will be cached).
      new Function("data", "var p=[],print=function(){p.push.apply(p,arguments);};" + "p.push('" + str
          .replace(/[\r\t\n]/g, " ")
          .split("<%").join("\t")
          .replace(/((^|%>)[^\t]*)'/g, "$1\r")
          .replace(/\t=(.*?)%>/g, "',$1,'")
          .split("\t").join("');")
          .split("%>").join("p.push('")
          .split("\r").join("\\'") + "');return p.join('');");

      return fn(data);
}

module.exports = { render: render };



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/template.js
 ** module id = 12
 ** module chunks = 0
 **/